import React from 'react';
import './Projects.css';

const Projects: React.FC = () => {
  const projects = [
    {
      title: 'AI Agents',
      description: 'AI Agents example repo.',
      technologies: ['Python', 'LangChain', 'LangGraph', 'LangSmith'],
      link: 'https://github.com/Marian505/new-agent'
    },
    {
      title: 'Debian k8s infara',
      description: 'On-prem runnig kubernetes cluster',
      technologies: ['Kubernetes', 'Debian', 'Helmfile', 'Microservices'],
      link: 'https://github.com/Marian505/debian-k8s-infra'
    }
  ];

  return (
    <section className="projects">
      <div className="projects-container">
        <h1 className="section-title">Projects</h1>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-technologies">
                {project.technologies.map((tech, techIndex) => (
                  <span key={techIndex} className="tech-tag">
                    {tech}
                  </span>
                ))}
              </div>
              <a href={project.link} className="project-link">
                GitHub Project →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;